module.exports = __webpack_public_path__ + "static/media/img_about_us.6ea5170e.jpg";